export const environment = {
  production: true,
  sentryDSN: "https://de1b06288c194bd8a0a272b68cebf28a@o363794.ingest.sentry.io/4520513",
  apiUrl: 'https://prodcw.cargotransnet.com/Api',
  mfePodUrl: 'https://wprodpod.cargotransnet.com/mf-proof-delivery.js',
  whiteList: ['prodcw.cargotransnet.com'],
  mapboxAccessToken: 'pk.eyJ1IjoiZXJuMTQiLCJhIjoiY202Z3ZsenprMDVyZTJqb2xxNm0wcWwyZyJ9.ox6fjuJZAZ1orN6b16Gk_g'
};
